<template>
  <nav>
   
    <Notification />
    <!-- <editCompany v-if="currentRouteName != 'dashboard-attendance' && currentRouteName != 'live-tracking'"></editCompany> -->
    <profile v-if="currentRouteName != 'dashboard-attendance' && currentRouteName != 'live-tracking'"></profile>
    <v-dialog v-model="logoutDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('logout') }}</v-card-title>
        <v-card-text>Are you sure want to logout?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="logoutDialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="signOut()">Log out</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="v3Dialog" max-width="600">
      <v-card>
        <v-card-title class="headline text-center justify-center">Change to Appsensi CMS V.3.0 ?</v-card-title>
        <v-card-text class="text-center">Are you sure want to change from Appsensi CMS V.2.0 to Appsensi CMS V.3.0 ? Please aware that you must re-log in to the account after change it.</v-card-text>
        <v-card-actions class="pa-3 text-center d-flex justify-center">
          <v-btn color="default" text @click="v3Dialog = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" @click="goV3()">{{ $t('change') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="billingInfo.latest_billing" overlay-opacity="0.7" v-model="planEnded" max-width="520px">
      <v-card class="pa-6">
        <h2>
          <v-img src="img/danger.png" style="width: 20px; height: 20px; display: inline-block;" class="mr-3">
          </v-img>
          Update your plan
        </h2>
        <br>
        <v-row align="center" justify-center class="mt-n4">
          <v-col>
            <p style="color: #3277D5; font-size: 12px; line-height: 16px;">
              {{ $t('extend') }}
            </p>
            <p style="font-size: 16px; line-height: 21px;" class="mt-n2">
              {{ $t('updatePlan') }}
            </p>
          </v-col>
          <v-col cols="4">
            <v-btn outlined color="primary"
              @click="[$router.push({ name: 'company' }), planEnded = false, $store.dispatch('toggleChangePlanModal', true)]">
              {{ $t('updatePlanBtn') }}
              </v-btn> </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-if="billingInfo.latest_billing" persistent overlay-opacity="0.7" v-model="overQuotaModal"
      max-width="520px">
      <v-card class="pa-6">
        <h2>
          <v-img src="img/danger.png" style="width: 20px; height: 20px; display: inline-block;" class="mr-3">
          </v-img>
          Overquota Active User
        </h2>
        <br>
        <p v-if="billingInfo.latest_billing.nextPayment" style="color: #E64A4D; font-size: 12px;">
          {{ $t('remainingTime') }} {{ checkDaysLefts(billingInfo.latest_billing.nextPayment) > 0 ? checkDaysLefts(billingInfo.latest_billing.nextPayment) : 0}} {{ $t('overQuotaDaysLeft') }}
          ({{ $t('until') }} {{ endContract(billingInfo.latest_billing.nextPayment)}})
        </p>
        <p style="font-size: 16px;">
          {{ $t('over') }}
          <span style="color: #E64A4D; font-weight: 500;">
            {{ billingInfo.latest_billing.activeUser - billingInfo.latest_billing.total_paid_user }}
          </span>
          {{ $t('activeUser') }}
        </p>
        <p style="font-size: 12px; color: #686868;">
          {{ $t('adjustUser') }}
        </p>

        <div class="d-flex mb-4">
          <router-link :to="{ name: 'employee' }" class="d-flex align-center px-3 py-2 rounded-lg"
            style="border: 1px solid #CDCDCD; text-decoration: none; color: black;"
            @click.native="$store.dispatch('toggleOverQuotaModal', false)">
            <img src="img/menu_icon/employee.png" class="icon-image mr-2" alt width="18" height="18" />
            <p class="mb-0 text-dark">
              {{ $t('employee') }}
            </p>
          </router-link>
        </div>

        <hr class="mb-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('sentEmail') }}
          <b>{{ checkCompanyInfo(companyInfo.email_pic) }}</b> {{ $t('asPIC') }} {{ companyInfo.companyName }}
        </p>
        <v-row align="center" justify-center class="mt-n4">
          <v-col cols="7" class="d-flex align-items-center">
            <p class="mb-0">{{ $t('changeContact') }}</p>
          </v-col>
          <v-col cols="4">
            <v-btn outlined color="primary"
              @click="[$route.path === '/company' ? '' : $router.push({ name: 'company' }), updatePlanModal = false, $store.dispatch('togglePICModal', true)]">
              {{ $t('changeContactBtn') }}</v-btn>
          </v-col>
        </v-row>

        <hr class="my-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('furtherInformation') }}</p>
        <b>support@appsensi.com</b>
        <v-col style="display: flex;" class="justify-center mt-4">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdNg9-Gxmi6IQZ9yYXMtTcQvFLFb1I4cxg90VpDhLu4oSmyHA/viewform"
            target="_blank" style="text-decoration: none;">
            <v-btn color="primary">{{ $t('updatePlanBtn') }}</v-btn>
          </a>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-if="billingInfo.latest_billing" overlay-opacity="0.7" v-model="updatePlanModal" max-width="520px">
      <v-card class="pa-6">
        <h2>
          <v-img src="img/warning.png" style="width: 20px; height: 20px; display: inline-block;" class="mr-3">
          </v-img>
          {{ companyInfo.type === 'Trial' ? 'Update trial plan' : 'Update your plan' }}
        </h2>
        <br>
        <p style="color: #E64A4D; font-size: 12px;">
          {{ $t('remainingTime') }} {{ checkDaysLefts(billingInfo.latest_billing.nextPayment) > 0 ? checkDaysLefts(billingInfo.latest_billing.nextPayment) : 0 }} {{ $t('daysLeft') }} ({{ $t('until') }}
          {{ endContract(billingInfo.latest_billing.nextPayment) }})
        </p>
        <template v-if="companyInfo.type !== 'Trial'">
          <p class="mb-0" style="font-size: 16px;">
            <strong>
              {{ companyInfo.companyName }} :
            </strong>
          </p>
          <p style="font-size: 18px; color: rgb(50, 119, 213);">
            <strong>
              {{ billingInfo.latest_billing.plan }}
            </strong>
          </p>
        </template>
        
        <p style="font-size: 16px;">
          {{ companyInfo.type === 'Trial' ? 
          $t('trialPeriod') : 
          $t('proPeriod')
          }}
        </p>

        <v-row align="center" justify-center class="mt-n4 mb-3">
          <v-col cols="7" class="d-flex align-items-center">
            <p class="mb-0">{{ $t('updatePlan') }}</p>
          </v-col>
          <v-col cols="4">
            <v-btn outlined color="primary"
              @click="[$router.push({ name: 'company' }), updatePlanModal = false, $store.dispatch('toggleChangePlanModal', true)]">
              {{ $t('updatePlanBtn') }} </v-btn>
          </v-col>
        </v-row>

        <hr class="mb-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('sentEmail') }}
          <b>{{ checkCompanyInfo(companyInfo.email_pic) }}</b> {{ $t('asPIC') }} {{ companyInfo.companyName }}
        </p>
        <v-row align="center" justify-center class="mt-n4">
          <v-col cols="7" class="d-flex align-items-center">
            <p class="mb-0">{{ $t('changeContact') }}</p>
          </v-col>
          <v-col cols="4">
            <v-btn outlined color="primary"
              @click="[$route.path === '/company' ? '' : $router.push({ name: 'company' }), updatePlanModal = false, $store.dispatch('togglePICModal', true)]">
              {{ $t('changeContactBtn') }}</v-btn>
          </v-col>
        </v-row>

        <hr class="my-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('furtherInformation') }}</p>
        <b>support@appsensi.com</b>
        <v-col style="display: flex;" class="justify-center mt-4">
          <v-btn color="primary" @click="updatePlanModal = false">{{ $t('understand') }}</v-btn>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-if="billingInfo.latest_billing" persistent overlay-opacity="0.7" v-model="disabledAccountModal"
      max-width="520px">
      <v-card class="pa-6">
        <h2>
          <v-img src="img/danger.png" style="width: 20px; height: 20px; display: inline-block;" class="mr-3">
          </v-img>
          Update your plan
        </h2>
        <br>
        <p style="font-size: 16px" class="mb-2">
          {{ companyInfo.companyName }} :
        </p>

        <p style="font-size: 16px; font-weight: 500; color: #3277D5">
          {{ billingInfo.latest_billing.plan }}
        </p>
        <p style="font-size: 16px;">
          {{ $t('proPeriod') }}
        </p>

        <v-row align="center" justify-center class="mt-n4 mb-3">
          <v-col cols="7" class="d-flex align-items-center">
            <p class="mb-0">{{ $t('updatePlan') }}</p>
          </v-col>
          <v-col cols="4">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdvDQLLjSCbahMnELLQVQEsgqfYa3vIjhRIXacivfBo2TY0ew/viewform?usp=sf_link"
              target="_blank" style="text-decoration: none;">
              <v-btn outlined color="primary">{{ $t('updatePlanBtn') }}</v-btn>
            </a>
          </v-col>
        </v-row>

        <hr class="mb-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('sentEmail') }}
          <b>{{ checkCompanyInfo(companyInfo.email_pic) }}</b> {{ $t('asPIC') }} {{ companyInfo.companyName }}
        </p>
        <v-row align="center" justify-center class="mt-n4">
          <v-col cols="7" class="d-flex align-items-center">
            <p class="mb-0">{{ $t('changeContact') }}</p>
          </v-col>
          <v-col cols="4">
            <v-btn outlined color="primary"
              @click="[$route.path === '/company' ? '' : $router.push({ name: 'company' }), updatePlanModal = false, $store.dispatch('togglePICModal', true)]">
              {{ $t('changeContactBtn') }}</v-btn>
          </v-col>
        </v-row>

        <hr class="my-4" style="border: 0.8px solid rgb(230, 230, 230);" />

        <p>{{ $t('furtherInformation') }}</p>
        <b>support@appsensi.com</b>

        <v-col style="display: flex;" class="justify-center mt-4">
          <v-btn color="error" @click="logoutDialog = true">LOGOUT</v-btn>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-if="billingInfo.latest_billing" overlay-opacity="0.7" v-model="changePIC" max-width="470px">
      <v-card class="pa-6">
        <h3>
          Change Contact
        </h3>
        <v-form class="mt-4">
          <v-text-field type="email" @keydown.space.prevent v-model="picEmail" label="Change Contact (PIC)"
            maxlength="50" :rules="emailRules">
          </v-text-field>
        </v-form>
        <v-row align="center" class="justify-center">
          <v-col cols="6" style="display: flex;" class="justify-end">
            <v-btn color="primary" outlined @click="changePIC = false" style="width: 100px;">CANCEL</v-btn>
          </v-col>
          <v-col cols="6" style="display: flex;" class="justify-start">
            <v-btn color="primary" style="width: 100px;">SAVE</v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog v-model="whatsNewDialog" max-width="900px">
      <v-card>
        <v-card-title class="font-weight-bold">
          What's New on Appsensi: Bulk Upload
        </v-card-title>
        <v-card-text>
          <WhatsNewCarousel />
        </v-card-text>
        <v-card-action class="pa-4 d-flex justify-center" style="gap: 16px;">
          <v-btn color="primary" outlined @click="checkWhatsNew()">I Understand</v-btn>
          <v-btn color="primary" @click="visitPayroll()">Visit Salary Component</v-btn>
        </v-card-action>
      </v-card>
    </v-dialog>


    <v-app-bar flat app v-if="currentRouteName != 'dashboard-attendance' && currentRouteName != 'live-tracking'"
      color="white">
      <v-app-bar-nav-icon v-if="!drawer" color="primary" @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-card width="250" flat v-show="!drawer">
        <!-- Logo Inside Sidebar -->
        <v-img class="py-3 ml-2" src="img/appsensi_logo.png" max-width="120" contain></v-img>
        <p class="mobile-versioning"><span v-if="environment">{{ environment }}</span>&nbsp; v{{ version }}</p>
      </v-card>
      <v-spacer></v-spacer>
      <!-- <div style="height: 60%" class="mr-3">
        <v-select 
          color="white"
          v-model="lang"
          :items="languages"
          item-text="name"
          item-value="id"
          class="language-switch custom-select"
          style="font-size: 12px; width: 120px; height: 100%"
          @change="changeLanguage($event)">
        </v-select>
      </div> -->
      <span class="hover-pointer feedbackText d-none d-lg-block" @click="goFeedback()" style="display: flex; align-items: center;">   <img class="feedbackicon" style="position: relative;" src="img/feedback.svg" alt="Feedback" width="20" height="20"></span>
      <span class="d-none d-lg-block" style="font-weight: 600; font-size: 14px;">Get <a @click="v3Dialog = true">Appsensi CMS V 3.0</a> here! <span style="border-right: 1px solid #C4C4C4; height: 39px; margin-left: 17px; margin-right: 17px;"></span></span>
      <!-- <span class="d-none d-lg-block" style="font-weight: 600; font-size: 14px;">Get <a @click="goOpt()">Appsensi Mobile V 3.0</a> here! <span style="border-right: 1px solid #C4C4C4; height: 39px; margin-left: 17px;"></span></span> -->
      <template v-if="companyInfo.type === 'Trial'">
        <span class="mr-2 ml-2"
          style="font-size: 14px; font-weight: 600; color: #E64A4D">
          {{ companyInfo.type }}
        </span>
      </template>
      <template v-else>
        <span v-if="billingInfo.latest_billing && billingInfo.latest_billing.nextPayment" class="mr-2 ml-2"
          style="font-size: 14px; font-weight: 600; color: #3277D5">
          {{ billingInfo.latest_billing.plan }}
        </span>
      </template>
      <span class="mr-2 d-none d-md-block" v-if="billingInfo.latest_billing && billingInfo.latest_billing.nextPayment && checkDaysLefts(billingInfo.latest_billing.nextPayment) <= 45"
        style="border-radius: 12px; padding: 2px 8px 2px 8px; font-size: 10px;"
        :style="checkDaysLefts(billingInfo.latest_billing.nextPayment) > 7 ? 'background-color:  rgba(67, 154, 212, 0.1);' : checkDaysLefts(billingInfo.latest_billing.nextPayment) <=3 ? 'background-color:  rgba(230, 74, 77, 0.1);' : 'background-color:  rgba(247, 147, 33, 0.1);'">
        <span @click="checkDaysLefts(billingInfo.latest_billing.nextPayment) <=7 ? planEnded = true : ''"
          style="font-weight: 600;"
          :style="checkDaysLefts(billingInfo.latest_billing.nextPayment) > 7 ? 'color: #4399D4;' : checkDaysLefts(billingInfo.latest_billing.nextPayment) <=3 ? 'color: #E64A4D;' : 'color: #F79421;'">{{
          checkDaysLefts(billingInfo.latest_billing.nextPayment) > 0 ? checkDaysLefts(billingInfo.latest_billing.nextPayment) : 0
        }} {{ $t('daysLeft') }}</span>
      </span>
      <v-menu class="d-none d-md-block" v-if="billingInfo.latest_billing" bottom nudge-top="-20px" nudge-left="180px" origin="center bottom"
        transition="scale-transition" :close-on-click="menuList.closeOnClick" offset-y>
        <template v-slot:activator="{ on }">
          <div class="d-none d-sm-block">
            <v-btn v-on="on" color="transparent" depressed large>
              <!-- <v-icon color="primary" left>mdi-account-circle</v-icon> -->
              &nbsp;
              <small>{{ $t('notification') }}</small>
              <div style="position: relative;">
                <img class="ml-2" style="relative" src="img/no-notification.png" />

                <div v-if="isNotReadCount > 0" style="background-color: #E64A4D; position: absolute; top: -2px; right: -2px; color: white; font-size: 8px; border-radius: 50%; width: 11px; height: 11px; display: flex; align-items:center; justify-content: center">
                  {{ isNotReadCount }}
                </div>
              </div>  
              <v-icon color="primary" right>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list width="360px" class="pa-4">
          <template v-if="notificationInfo.notification_messages && notifCount > 0">
            <div v-for="(item, i) in notificationInfo.notification_messages" :key="i + 'a'">
              <v-list-item v-if="item.status" @click="openNotif(notificationInfo.id, item)">
                <v-list-item-title>
                  <p style="line-height: 21px;"><span v-if="!item.isRead" class="red-notification"></span>{{
                    item.message
                  }}</p>
                  <span style="color: #686868; font-size: 12px;">{{
                    item.dayPast
                  }} Days ago</span>
                  <hr :style="displayNone(i)" class="mt-4 mb-4" style="border: 0.8px solid #E6E6E6;">
                </v-list-item-title>
              </v-list-item>
            </div>
          </template>
          <template v-else>
            <p class="mb-0" style="font-size: 14px;">
              Tidak ada Notifikasi
            </p>
          </template>
        </v-list>
      </v-menu>
      <v-menu bottom nudge-top="-20px" origin="center bottom" transition="scale-transition"
        :close-on-click="menuList.closeOnClick" offset-y>
        <template v-slot:activator="{ on }">
          <div>
            <v-btn v-on="on" color="transparent" depressed large>
              <!-- <v-icon color="primary" left>mdi-account-circle</v-icon> -->
              &nbsp;
              <small>{{ checkLanguages(lang) }}</small>
              <v-icon color="primary" right>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in languages" :key="i + 'a'" @click="changeLanguage(item.id)" ripple>

            <v-list-item-title>
              <p class="mb-0" style="font-size: 14px;">
                {{ item.name }}
              </p>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <router-link :to="{ name: 'maintenance' }">
        <v-btn icon v-show="isAdministrator">
          <!-- <unicon name="gears" fill="royalblue" icon-style="monochrome"></unicon> -->
          <v-icon color="primary">mdi-cog-box</v-icon>
        </v-btn>
      </router-link>
      <!-- <v-menu
        attach
        nudge-top="-10px"
        bottom
        origin="center center"
        transition="scale-transition"
        :close-on-click="menuList.closeOnClick"
        offset-y
      > -->
      <div v-show="isAdminHRD" class="ml-3 mr-3 d-none d-md-block">
        <v-btn color="primary" class="download-button" @click="downloadManual()">
          <small style="font-size: 13px" class="font-weight-medium">{{ $t('user_manual') }}</small>
        </v-btn>
      </div>
      <!-- <v-list class="pa-0 ma-0">
          <v-list-item class="pa-0 ma-0 hover-pointer">
            <v-list-item-icon class="mr-5">
              <v-icon color="primary">mdi-download</v-icon>
            </v-list-item-icon>
            <small class="sae-grey">Summary for HR</small>
          </v-list-item>
          <v-list-item class="pa-0 ma-0 hover-pointer">
            <v-list-item-icon class="mr-5">
              <v-icon color="primary">mdi-download</v-icon>
            </v-list-item-icon>
            <small class="sae-grey">Summary for User</small>
          </v-list-item>
        </v-list>
      </v-menu> -->
      <v-menu bottom nudge-top="-20px" origin="center bottom" transition="scale-transition"
        :close-on-click="menuList.closeOnClick" offset-y>
        <template v-slot:activator="{ on }">
          <div>
            <v-btn v-on="on" color="transparent" depressed large>
              <v-avatar size="32" class="ma-1">
                <img :src="avatarUrl" alt="Avatar"
                  onerror="this.onerror=null;this.src='img/logo_initial_gradient.png'" />
              </v-avatar>
              <!-- <v-icon color="primary" left>mdi-account-circle</v-icon> -->
              &nbsp;
              <small>{{ userName | split }}</small>
              <v-icon color="primary" right>mdi-chevron-down</v-icon>
            </v-btn>
          </div>
        </template>

        <v-list>
          <v-list-item v-for="(item, i) in menuList.items" :key="i + 'a'" @click="changeRoute(item)" ripple>
            <v-list-item-icon>
              <!-- <unicon :name="item? item.icon : null" fill="royalblue" icon-style="monochrome"></unicon> -->
              <v-icon color="primary">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer class="white" v-model="drawer" width="250" app floating>
      <template v-slot:prepend>
        <v-toolbar flat class>
          <v-app-bar-nav-icon class="d-none d-lg-block" color="primary" @click="drawer = !drawer"></v-app-bar-nav-icon>
          <!-- Logo Inside Header -->
          <v-img class="py-3 ml-lg-2 mx-auto" src="img/appsensi_logo.png" max-width="120" contain> </v-img>
          <p class="desktop-versioning"><span v-if="environment">{{ environment }}</span>&nbsp; v{{ version }}</p>
        </v-toolbar>
      </template>
      <v-card>
        <v-list class="f-14 new-navbar" rounded>
          <v-list-item class="pa-0 child-link">
            <v-container class="pl-0">
              <!-- Menu -->
              <v-list-item-title class="f-10 font-weight-bold mt-3 sae-grey ml-3">{{
                $t('nav_menu')
              }}</v-list-item-title>
              <!-- <v-divider></v-divider> -->

              <v-list-item v-for="(item, i) in links" :key="i + 'b'" ripple router :to="item ? item.route : ''"
                @click="gtag(item.gtag.event, 'summary_report', item.gtag.label)" class="pl-3 child-link">
                <v-list-item-icon class="mr-2">
                  <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Attendance -->
              <v-list-group :value="checkRoute('attendance')" class="sae child-group">
                <template v-slot:activator>
                  <img :src="attendance.icon" alt class="mr-3 ml-3 icon-image" width="18" height="18" />
                  <v-list-item-title>{{ attendance.title }}</v-list-item-title>
                </template>
                <v-list-item v-for="(item, i) in attendance.items" :key="i + 'c'" ripple router
                  :to="item ? item.route : ''" @click="gtag(item.gtag.event, 'attendance', item.gtag.label)"
                  class="pl-3">
                  <v-list-item-icon class="mr-2">
                    <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="group-children" v-text="item ? item.text : null"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <!-- Report -->
              <v-list-group :value="checkRoute('report')" class="sae child-group">
                <template v-slot:activator>
                  <img :src="reports.icon" alt class="mr-3 ml-3 icon-image" width="18" height="18" />
                  <v-list-item-title>{{ reports.title }}</v-list-item-title>
                </template>

                <v-list-item v-for="(item, i) in reports.items" :key="i + 'd'" ripple router
                  :to="item ? item.route : ''" @click="gtag(item.gtag.event, 'report', item.gtag.label)" class="pl-3">
                  <v-list-item-icon class="mr-2">
                    <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <!-- Task Assignment -->
              <v-list-item v-for="(item, i) in taskAssignment" :key="i + 'e'" ripple router :to="item ? item.route : ''"
                @click="gtag(item.gtag.event, 'task_assignment', item.gtag.label)" class="pl-3">
                <v-list-item-icon class="mr-2">
                  <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Live Tracking -->
              <v-list-item v-for="(item, i) in liveTracking" :key="i + 'lv'" ripple router :to="item ? item.route : ''"
                class="pl-3">
                <v-list-item-icon class="mr-2">
                  <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- Manage -->
              <v-list-item-title class="f-10 font-weight-bold mt-3 sae-grey ml-3" v-show="manageMenu">{{
                $t('nav_manage')
              }}</v-list-item-title>
              <!-- <v-divider v-show="manageMenu"></v-divider> -->
              <v-list-item-group :value="checkRoute('manage')" class>
                <template v-slot:activator>
                  <v-list-item-title>{{ manage.title }}</v-list-item-title>
                </template>

                <v-list-item v-for="(item, i) in manage.items" :key="i + 'f'" ripple router :to="item ? item.route : ''"
                  @click="gtag(item.gtag.event, 'manage', item.gtag.label)" class="pl-3">
                  <v-list-item-icon class="mr-2">
                    <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>

              <!-- Payroll -->
              <v-list-group :value="checkRoute('payroll')" class="sae child-group" v-if="gcPayrollEnabled && notSupervisor">
                <template v-slot:activator>
                  <img :src="payroll.icon" alt class="mr-3 ml-3" width="18" height="18" />
                  <v-list-item-title>{{ payroll.title }}</v-list-item-title>
                </template>

                <v-list-item v-for="(item, i) in payroll.items" :key="i + 'd'" ripple router
                  :to="item ? item.route : ''" @click="gtag(item.gtag.event, 'payroll', item.gtag.label)" class="pl-3">
                  <v-list-item-icon class="mr-2">
                    <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>

              <!-- Setting -->
              <v-list-item-title class="f-10 font-weight-bold mt-3 sae-grey ml-3" v-show="settingMenu">{{
                $t('nav_setting')
              }}</v-list-item-title>
              <!-- <v-divider v-show="settingMenu"></v-divider> -->
              <v-list-item-group :value="checkRoute('setting')" class>
                <template v-slot:activator>
                  <v-list-item-title>{{ admin.title }}</v-list-item-title>
                </template>

                <v-list-item v-for="(item, i) in admin.items" :key="i + 'g'" ripple router :to="item ? item.route : ''"
                  @click="gtag(item.gtag.event, 'setting', item.gtag.label)" class="pl-3">
                  <v-list-item-icon class="mr-2">
                    <img :src="item ? item.icon : null" class="icon-image" alt width="18" height="18" />
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="item ? item.text : null"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-container>
          </v-list-item>
        </v-list>
      </v-card>
    </v-navigation-drawer>
  </nav>
</template>

<script>
  import moment from "moment";
  import {
    version
  } from '../../package.json'
  import firebase from "firebase";
  // import editCompany from "../views/EditCompany";
  import profile from "../views/Profile";
  import axios from "axios";
  import Notification from './Notification'
  import ENV from "./../store/modules/environtment";
  import WhatsNewCarousel from './WhatsNewCarousel'

  export default {
    name: "Navbar",
    data() {
      const lang = localStorage.getItem('lang') || 'id';
      let tmp = {
        baseUrl: this.$store.state.baseUrl,
        userManual: this.$store.state.user_manual,
        logoutDialog: false,
        v3Dialog: false,
        menuList: {
          closeOnClick: true,
          items: [{
              route: "profile",
              title: this.$i18n.t('profile'),
              icon: "mdi-account"
            },
            // {
            //   route: "company",
            //   title: this.$i18n.t('nav_company'),
            //   icon: "mdi-account-group-outline",
            // },
            {
              route: "logout",
              title: this.$i18n.t('logout'),
              icon: "mdi-logout-variant"
            },
          ],
          menu: [],
        },
        whatsNewDialog: false,
        // whatsNewDialog: localStorage.getItem('newDialog') || true,
        todayDate: moment().locale(this.$i18n.t('lang')).format('D-M-YYYY'),
        lang: lang,
        notificationInfo: [],
        languages: [{
            name: 'ENGLISH',
            id: 'en'
          },
          {
            name: 'BAHASA',
            id: 'id'
          },
        ],
        version: version,
        drawer: true,
        user: {},
        companies: [],
        companyInfo: [],
        notifCount: 0,
        isNotReadCount: 0,
        // billingInfo: [],
        picEmail: '',
        administrator: false,
        planEnded: false,
        // overQuotaModal: false,
        updatePlanModal: false,
        disabledAccountModal: false,
        changePIC: false,
        emailRules: [
          (v) => !v || /.+@.+\..+/.test(v) || this.$i18n.t('email_required'),
        ],
        links: [
          // { icon: "img/menu_icon/menu_dashboard.png", text: "Dashboard", route: "/dashboard" },
          {
            icon: "img/menu_icon/summary.png",
            text: this.$i18n.t('nav_summary_report'),
            route: "/summary-report",
            gtag: {
              event: "summary_report",
              label: "Summary Report"
            }
          },
        ],
        taskAssignment: [{
          icon: "img/menu_icon/task_assigment.png",
          text: this.$i18n.t('nav_task'),
          route: "/task-assignment",
          gtag: {
            event: "task_assignment",
            label: "Task Assignment"
          }
        }, ],
        liveTracking: [{
          icon: "img/menu_icon/live_tracking.png",
          text: this.$i18n.t('live_tracking'),
          route: "/live-tracking",
        }, ],
        attendance: {
          icon: "img/menu_icon/attendance.png",
          title: this.$i18n.t('nav_attendance'),
          active: true,
          items: [
            // {
            //   icon: "'img/menu_icon/transparent.png",
            //   text: "Daily Attendance",
            //   route: "/daily-attendance",
            // },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_location_map'),
              route: "/dashboard-attendance",
              gtag: {
                event: "attendance_location_map",
                label: "Attendance (Location Map)"
              }
            },

            // {
            //   icon: "img/menu_icon/transparent.png",
            //   text: "Daily Attendance",
            //   route: "/daily",
            // },
            // {
            //   icon: "'img/menu_icon/transparent.png",
            //   text: "User Attendance",
            //   route: "/user-attendance",
            // },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_issue_attendance'),
              route: "/issue-attendance",
              gtag: {
                event: "attendance_issue_attendance",
                label: "Attendance (Issue Attendance)"
              }
            },
          ],
        },
        reports: {
          icon: "img/menu_icon/report.png",
          title: this.$i18n.t('nav_report'),
          active: true,
          items: [{
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_attendance_report'),
              route: "/activity-report",
              gtag: {
                event: "report_attendance_report",
                label: "Report (Attendance Report)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_monthly_report'),
              route: "/monthly-report",
              gtag: {
                event: "report_monthly_report",
                label: "Report (Monthly Report)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_user_report'),
              route: "/user-report",
              gtag: {
                event: "report_user_report",
                label: "Report (User Report)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_activity_report'),
              route: "/list-activity",
              gtag: {
                event: "report_activity_report",
                label: "Report (Activity Report)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_user_summary'),
              route: "/issues-report",
              gtag: {
                event: "report_user_summary",
                label: "Report (User Summary)"
              }
            },
          ],
        },
        payrollNew: {
          icon: "img/menu_icon/payroll.png",
          title: "Payroll New",
          active: true,
          items: [{
              icon: "img/menu_icon/transparent.png",
              text: "Salary Component",
              route: "/salary-component",
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: "Period",
              route: "/period",
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: "Payroll Process",
              route: "/payroll-process",
            },
          ],
        },

        manage: {
          icon: "user-md",
          title: this.$i18n.t('nav_manage'),
          active: true,
          items: [{
              icon: "img/menu_icon/schedule.png",
              text: this.$i18n.t('nav_schedule'),
              route: "/schedule",
              gtag: {
                event: "schedule",
                label: "Schedule"
              }
            },
            {
              icon: "img/menu_icon/schedule.png",
              text: this.$i18n.t('shifting'),
              route: "/shifting",
              gtag: {
                event: "shifting",
                label: "Shifting"
              }
            },
            {
              icon: "img/menu_icon/approval.png",
              text: this.$i18n.t('nav_approvals'),
              route: "/approval",
              gtag: {
                event: "approvals",
                label: "Approvals"
              }
            },
            {
              icon: "img/menu_icon/master_data.png",
              text: this.$i18n.t('nav_master_data'),
              route: "/master-data",
              gtag: {
                event: "master_data",
                label: "Master Data"
              }
            },
            {
              icon: "img/menu_icon/leave_balance.png",
              text: this.$i18n.t('leave'),
              route: "/leave",
            },
            {
              icon: "img/menu_icon/calendar.png",
              text: this.$i18n.t('nav_calendar'),
              route: "/calendar",
              gtag: {
                event: "calendar",
                label: "Calendar"
              }
            },
            {
              icon: "img/menu_icon/news_feed.png",
              text: this.$i18n.t('nav_news'),
              route: "/news-feed",
              gtag: {
                event: "news_feed",
                label: "News Feed"
              }
            },
            {
              icon: "img/menu_icon/audit-trail.png",
              text: this.$i18n.t('nav_audit'),
              route: "/audit-trail",
              gtag: {
                event: "audit_trail",
                label: "Audit Trail"
              }
            },
          ],
        },
        payroll: {
          icon: "img/menu_icon/payroll.png",
          title: this.$i18n.t('nav_payroll'),
        },
        admin: {
          icon: "lock-access",
          title: this.$i18n.t('nav_setting'),
          active: true,
          items: [{
              icon: "img/menu_icon/employee.png",
              text: this.$i18n.t('nav_employee'),
              route: "/employee",
              gtag: {
                event: "employee",
                label: "Employee"
              }
            },
            {
              icon: "img/menu_icon/group.png",
              text: this.$i18n.t('nav_groups'),
              route: "/groups",
              gtag: {
                event: "groups",
                label: "Groups"
              }
            },
            {
              icon: "img/menu_icon/zones.png",
              text: this.$i18n.t('nav_zones'),
              route: "/zones",
              gtag: {
                event: "zones",
                label: "Zones"
              }
            },
            {
              icon: "img/menu_icon/new-company.png",
              text: this.$i18n.t('nav_company'),
              route: "/company",
              gtag: {
                event: "company",
                label: "Company"
              }
            },
          ],
        },
        manageMenu: true,
        settingMenu: true,
      };

      return tmp;
    },
    mounted() {
      let tmp = this

      if (this.$store.state.company != "bhinneka") {
        tmp.reports.items = tmp.reports.items.filter(
          (val) => val.text != this.$i18n.t('sub_attendance_report')
        );
      }

      if (!this.excludeShifting() ) {
        tmp.manage.items = tmp.manage.items.filter(
          (val) => val.text != this.$i18n.t('nav_schedule')
        );
      }
      
      // if ( (this.$store.state.company == "prima-hotel" && this.$store.state.role == 3) || (this.$store.state.company == "prima-hotel" && this.$store.state.role == 4) ) {
      //   tmp.manage.items = tmp.manage.items.filter(
      //     (val) => val.text != this.$i18n.t('nav_schedule')
      //   );
      // }

      if (this.excludeShifting()) {
        tmp.manage.items = tmp.manage.items.filter(
          (val) => val.text != this.$i18n.t('shifting')
        );
      }

      if (this.$store.state.role == 3) {
        tmp.reports.items = tmp.reports.items.filter(
          (val) => val.text != this.$i18n.t('sub_monthly_report') && val.text != this.$i18n.t('sub_user_report')
        );
      }

      // Hide Task Assigment base on firebase
      if (!this.gcTaskAssigmentEnabled) {
        tmp.taskAssignment = tmp.taskAssignment.filter(
          (val) => val.text != this.$i18n.t('nav_task')
        );
      }

      if (!this.gcLiveTrackingEnabled) {
        tmp.liveTracking = tmp.liveTracking.filter(
          (val) => val.text != this.$i18n.t('live_tracking')
        );
      }

      // Hide Location map base on firebase
      if (!this.gcLocationMapEnabled) {
        tmp.attendance.items = tmp.attendance.items.filter(
          (val) => val.text != this.$i18n.t('sub_location_map')
        );
      }

      // Hide Activity Report from firebase
      if (!this.gcActivityEnabled) {
        tmp.reports.items = tmp.reports.items.filter(
          (val) => val.text != this.$i18n.t('sub_activity_report')
        );
      }

      // Hide Audit Trail from firebase
      if (!this.gcAuditTrailEnabled) {
        tmp.manage.items = tmp.manage.items.filter(
          (val) => val.text != this.$i18n.t('nav_audit')
        );
      }

      if (!this.gcLeaveBalanceEnabled) {
        tmp.manage.items = tmp.manage.items.filter(
          (val) => val.text != this.$i18n.t('leave')
        );
      }

      // Hide News Feed from firebase
      if (!this.gcNewsFeedEnabled) {
        tmp.manage.items = tmp.manage.items.filter(
          (val) => val.text != this.$i18n.t('nav_news')
        );
      }

      // Hide Payroll from firebase
      this.checkMenuPayroll(this.gcPayrollEnabled)

      switch (this.$store.state.role) {
        // Admin HRD canot see task Assigment
        case 0:
          if (this.gcTaskAssigmentForSPV) {
            tmp.taskAssignment = tmp.taskAssignment.filter(
              (val) => val.text != this.$i18n.t('nav_task')
            )
          }
          break
        case 3:
          // supervisor can access schedule only active this when menu schedule active
          tmp.manage.items = tmp.manage.items.filter((e) => {
            return e.text == this.$i18n.t('nav_schedule') || e.text == this.$i18n.t('nav_approvals') || e.text == this.$i18n.t('shifting');
            
          })
          tmp.admin.items = tmp.admin.items.filter((e) => {
            return e.text == this.$i18n.t('nav_company')
          })
          tmp.settingMenu = true;
          break;
        case 4:
          tmp.settingMenu = false;
          tmp.admin = {};

          tmp.manageMenu = false;
          tmp.manage = {};
          break;
      }
    },
    methods: {
      checkRoute(menu) {
        const url = this.$route.name
        switch(menu) {
          case 'attendance':
            if (url === 'dashboard-attendance' || url === 'issue-attendance') {
              return true
            } else {
              return false
            }
          case 'report':
            if (url === 'monthly-report' || url === 'user-report' || url === 'list-activity' || url === 'issues-report') {
              return true
            } else {
              return false
            }
          case 'payroll':
            if (url === 'salary-component' || url === 'bpjs' || url === 'supporting-components' || url === 'period-setting' || url === 'payroll-process') {
              return true
            } else {
              return false
            }
          default:
            return false
        }
      },
      displayNone(i) {
        // eslint-disable-next-line no-console
        // console.log(i)
        if (i === 4) {
          return 'display: none; margin-top: -20px;'
        } else {
          return ''
        }
      },
      checkCompanyInfo(companyEmail) {
        if (companyEmail) {
          return companyEmail
        } else {
          'You have No PIC email, please update it.'
        }
      },
      gtag(event, category, label) {
        window.gtag('event', event, {
          'event_category': category,
          'event_label': label
        })
      },
      checkCompanyType(type) {
        // Onboarded (biru) 
        // End Trial (merah) 
        // Trial (biru) 
        // Stop Onboarded (merah) 
        // Internal (biru) 
        // Stop (merah)

        if (type === 'Onboarded' || type === 'Trial' || type === 'Internal') {
          return true
        } else {
          return false
        }
      },
      checkDaysLefts(date) {
        const endContract = moment(date)
        const today = moment()
        // eslint-disable-next-line no-console
        return Math.ceil(endContract.diff(today, 'days', true))
      },
      checkLanguages(languages) {
        if (languages === 'en') {
          return 'ENGLISH'
        } else {
          return 'BAHASA'
        }
      },
      checkMenuPayroll(enabled = true) {
        if (enabled) {
          this.payroll.items = [{
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_salary_component'),
              route: "/salary-component",
              gtag: {
                event: "payroll_salary_component",
                label: "Payroll (Salary Component)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('supporting_components'),
              route: "/supporting-components",
              gtag: {
                event: "supporting_componenst",
                label: "Payroll (Supporting Components)"
              }
            },
            // {
            //   icon: "img/menu_icon/transparent.png",
            //   text: this.$i18n.t('sub_tax'),
            //   route: "/tax",
            //   gtag: {
            //     event: "payroll_tax",
            //     label: "Payroll (Tax)"
            //   }
            // },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_period'),
              route: "/period-setting",
              gtag: {
                event: "payroll_period_settings",
                label: "Payroll (Period Settings)"
              }
            },
            {
              icon: "img/menu_icon/transparent.png",
              text: this.$i18n.t('sub_process'),
              route: "/payroll-process",
              gtag: {
                event: "payroll_payroll_process",
                label: "Payroll (Payroll Process)"
              }
            },
          ]
        } else {
          this.payroll.items = []
        }
      },
      changeLanguage(event) {
        this.lang = event;
        localStorage.setItem('lang', event)
        window.location.reload();
      },
      changeRoute(item) {
        switch (item.route) {
          case "logout":
            this.logoutDialog = true;
            break;
            // case "company":
            //   this.$store.dispatch("companyDrawer", true);
            //   break;
          case "profile":
            this.$store.dispatch("profileDrawer", true);
            break;

          default:
            if (this.$router.currentRoute.name != item.route) {
              this.$router.push({
                name: item.route
              });
            }
            break;
        }
      },
      signOut() {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.$store.dispatch("signOut");
            this.$router.push({
              name: "login"
            });
          });
      },
      async setUser() {
        return firebase
        .firestore()
        .collection(ENV.firebase.user)
        .doc(this.$store.state.user.id)
        .set({whatsNewBulkUploadClicked: false}, {merge: true})
    },
    async getUser() {
        return firebase
        .firestore()
        .collection(ENV.firebase.user)
        .doc(this.$store.state.user.id)
        .get()
        .then((snapshot) => {
             if(snapshot.data().whatsNewBulkUploadClicked == undefined){
              this.whatsNewDialog = true
            }else{
              this.whatsNewDialog = snapshot.data().whatsNewBulkUploadClicked
            }
            })
    },
      downloadManual() {
        window.open(this.userManual, '_blank')
      },

      goOpt(){
         this.gtag('optv3', 'optv3', 'Opt V3 Mobile')
        window.open('https://appsensi.com/product-update-rilis-appsensi-mobile-v3/', '_blank')
      },

      goV3() {
      this.gtag('cmsv3', 'cmsv3', 'Opt CMS V3');
      this.$cookie.set('optv3', 'true')
      if (ENV.EnvUsed == 'staging'){
        window.open('https://admin-cms-v3-staging.web.app', '_self');
      }else if (ENV.EnvUsed == 'dev') {
        window.open('https://admin.appsensi.com', '_self');
      } else {
        window.open('https://admin.appsensi.com', '_self');
      }
      },

      goFeedback(){
        this.gtag('feedback', 'feedback', 'Feedback')
        window.open('https://docs.google.com/forms/d/e/1FAIpQLSfAmACsx8r7rj2Ay-D0tM0OBc2V2I7ZAHH-aSkSo3qJy7j7vg/viewform')
      },
      getCompanyInfo() {
        let company_id = this.$store.state.company;
        const url = `${this.baseUrl}/v1/companies/${company_id}`;
        axios.get(url, {
          headers: {
            action: "Get Company Info",
            actionId: 4
          }
        }).then((res) => {
          this.companyInfo = res.data.data;
          this.picEmail = res.data.data.email_pic
          this.checkEndSubscribe(this.billingInfo.latest_billing.nextPayment)
        });
        // eslint-disable-next-line no-console
        // console.log(this.companyInfo);
      },
      // getBillingInfo() {
      //   let company_id = this.$store.state.company;
      //   const url = `${this.baseUrl}/v3/billing/listbycompanyid?companyId=${company_id}`;
      //   axios.get(url, { headers: { action: "Get Billing Info", actionId: 4 } }).then((res) => {
      //     // eslint-disable-next-line no-console
      //     // console.log(res.data.data[0]);
      //     this.billingInfo = res.data.data[0];

      //     this.checkEndSubscribe(this.billingInfo.nextPayment)
      //   });
      // },
      checkEndSubscribe(data) {
        const endSubscribe = moment(data)
        const today = moment()
        const endDate = Math.ceil(endSubscribe.diff(today, 'days', true))
        if (endDate <= 0) {
          this.disabledAccountModal = true
        } else {
          this.disabledAccountModal = false
        }
      },
      checkWhatsNew () {
        this.whatsNewDialog = false
       this.setUser()
      },
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      endContract(date) {
        return moment(date).format('DD MMMM YYYY')
      },
      async openNotif(id, data) {
        if (data.isRead) {
          switch (data.id) {
            case 1:
              this.$store.dispatch('toggleOverQuotaModal', true)
              break;
            case 2:
            case 3:
            case 4:
            case 5:
              this.updatePlanModal = true;
              break;
          }
        } else {
          let body = {};
          switch (data.id) {
            case 1:
              body = {
                id: id,
                overQuotaIsRead: true
              };
              this.$store.dispatch('toggleOverQuotaModal', true)
              break;
            case 2:
              body = {
                id: id,
                notif1: true
              };
              this.updatePlanModal = true;
              break;
            case 3:
              body = {
                id: id,
                notif2: true
              };
              this.updatePlanModal = true;
              break;
            case 4:
              body = {
                id: id,
                notif3: true
              };
              this.updatePlanModal = true;
              break;
            case 5:
              body = {
                id: id,
                notif4: true
              };
              this.updatePlanModal = true;
              break;
          }
          const url = `${this.baseUrl}/updateNotifSoftCap`;
          const result = await axios.put(url, body, {
            headers: {
              action: "Update Company Notification",
              actionId: 2
            }
          })
          if (result) {
            if (result.data.code === 200) {
              // eslint-disable-next-line no-console
              // console.log("sukses");
              this.getNotification()
            } else {
              this.showMessage('warning', result.data.message)
              // eslint-disable-next-line no-console
              // console.log("gagal");
            }
          }
        }
      },
      async getNotification() {
        const url = `${this.baseUrl}/getNotificationInbox?userId=${this.$store.state.user.id}`;
        await axios.get(url, {
          headers: {
            action: "Get Company Notification",
            actionId: 4
          }
        }).then((res) => {
          this.notificationInfo = res.data.data;
          this.checkNotificationCount(this.notificationInfo)
          this.checkNotIsReadNotificationCount(this.notificationInfo)

          // if(this.notificationInfo.notification_messages[0].status) {
          //   this.$store.dispatch('toggleOverQuotaModal', true)
          // }
          // eslint-disable-next-line no-console
          // console.log(this.notificationInfo.notification_messages[0].status);
        });
      },
      checkNotificationCount(data) {
        for(const item in data.notification_messages) {
          if(data.notification_messages[item].status) {
            this.notifCount++
          }
        }
      },

      checkNotIsReadNotificationCount(data) {
        for(const item in data.notification_messages) {
          if(data.notification_messages[item].status && !data.notification_messages[item].isRead) {
            this.isNotReadCount++
          }
        }
      },
      visitPayroll () {
        this.setUser()
        this.$router.push({ path: '/salary-component' })
        this.whatsNewDialog = false
      },
      excludeShifting(){
        switch (this.$store.state.company) {
          case 'trubus-bina-swadaya':
            return true;
          case 'prima-hotel':
            return true;
          // case 'bhinneka':
          //   return true;
          // case 'aku-shopee-food':
          //   return true;
          case 'united-equipment-indonesia':
            return true;
          default:
            return false;
        }
      }



    },
    async created() {
      const optv3 = this.$cookie.get('optv3');
      const query = this.$route.query
       // eslint-disable-next-line no-console
      // console.log(query.opt)
      if(query.opt){
        this.$cookie.delete('optv3');
      }
      if(optv3 === 'true'){
        this.goV3()
      }
      

      this.getUser()
      // eslint-disable-next-line no-console
      // console.log(this.getUser)
      this.getCompanyInfo()
      // this.getBillingInfo()
      if (this.billingInfo.latest_billing) {
        this.getNotification()
        if (this.billingInfo.latest_billing.activeUser > this.billingInfo.latest_billing.total_paid_user) {
          this.$store.dispatch('toggleOverQuotaModal', true)
        }
      }
      const body = await this.$store.getters.gcGetParams
      await this.$store.dispatch('gcGetDataCompany', body)

      const data = await this.$store.dispatch('getGlobalConfig', {
        userId: this.$store.state.user.id
      })
      await this.$store.dispatch('setDataLogin', data)
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.user.avatar_url =
            "https://storage.cloud.google.com/appsensi-dev.appspot.com/images/avatars/" +
            user.uid;
        }
      });
    },
    // getCompany() {
    //   let company_id = this.$store.state.company;
    //   const url = `${this.baseUrl}/company/findbyid?companyId=${company_id}`;
    //   axios.get(url, { headers: { action: "Get Company", actionId: 4 } }).then((res) => {
    //     this.companies = res.data.data;
    //   });
    //   // eslint-disable-next-line no-console
    //   console.log(this.companies);
    // },
    computed: {
      environment() {
        if (ENV.EnvUsed == 'staging')
          return 'Staging'
        else if (ENV.EnvUsed == 'dev') {
          return 'Development'
        } else {
          return null
        }
      },
      company() {
        return this.$store.state.company;
      },
      avatarUrl() {
        return this.$store.state.user.avatar;
      },
      userName() {
        return this.$store.state.user_name;
      },
      userEmail() {
        return this.$store.state.user_email;
      },
      isAdministrator() {
        return this.$store.state.administrator;
      },
      notSupervisor() {
        if (this.$store.state.role != 3) {
          return true
        } else {
          return false
        }
      },
      isAdminHRD() {
        if (this.$store.state.role == 0) {
          return true
        } else {
          return false
        }
      },
      currentRouteName() {
        return this.$route.name;
      },
      gcLiveTrackingEnabled() {
        return this.$store.getters.gcGetData('feature_live_tracking', 'isTrackLocation')
      },
      gcLeaveBalanceEnabled() {
        return this.$store.getters.gcGetData('feature_leave', 'balance_is_enabled')
      },
      gcTaskAssigmentEnabled() {
        return this.$store.getters.gcGetData('feature_task_assignment', 'is_enabled')
      },
      gcTaskAssigmentForSPV() {
        return this.$store.getters.gcGetData('feature_task_assignment', 'is_spv_only')
      },
      gcLocationMapEnabled() {
        return this.$store.getters.gcGetData('config_cms', 'is_map_location_enabled')
      },
      gcActivityEnabled() {
        return this.$store.getters.gcGetData('feature_activity', 'is_enabled')
      },
      gcAuditTrailEnabled() {
        return this.$store.getters.gcGetData('audit_trail', 'is_enabled')
      },
      gcNewsFeedEnabled() {
        return this.$store.getters.gcGetData('feature_news_feed', 'is_enabled')
      },
      gcPayrollEnabled() {
        return this.$store.getters.gcGetData('feature_payroll', 'is_enabled')
      },
      billingInfo() {
        return this.$store.getters.getBillingInfo
      },
      overQuotaModal() {
        return this.$store.getters.getShowOverQuotaModal;
      }
    },
    watch: {
      gcPayrollEnabled(enabled) {
        this.checkMenuPayroll(enabled)
      }
    },
    components: {
      // editCompany,
      profile,
      Notification,
      WhatsNewCarousel
    },
  };
</script>
<style>
  .custom-select.v-text-field>.v-input__control>.v-input__slot:before {
    border-style: none;
  }

  .custom-select.v-text-field>.v-input__control>.v-input__slot:after {
    border-style: none;
  }

  .sae-required label::after {
    content: " *";
    color: red;
  }

  .sae-required-div div::after {
    content: " *";
    color: red;
  }

  .label-12 label {
    font-size: 12px;
  }

  #app-logo {
    height: 30px;
  }

  .f-10 {
    font-size: 10px !important;
  }

  .f-12 {
    font-size: 12px !important;
  }

  .f-14 {
    font-size: 14px !important;
  }

  .hide-icon .v-list-item__icon {
    display: none;
  }

  .attendance:before {
    content: "\F0494";
  }
  .feedbackText::before {
  content: 'FEEDBACK';
  position: absolute;
  left: 65px;
  transform: translateX(-50%);
  color: #FFFFFF;
  font-size: 14px;
}


  .sae .v-list-item {
    padding-left: 0 !important;
  }

  .f-14 .v-list-item .v-list-item__title,
  .f-14 .v-list-item .v-list-item__content {
    font-size: 14px !important;
  }

  nav .v-list-item__title {
    color: black;
    z-index: 99;
  }

  .v-list-item__title {
    color: #858585;
    z-index: 99;
  }

  .sae-grey {
    color: #858585;
  }

  :not(.v-list-group__header).v-list-item--active .v-list-item__title {
    color: black !important;
    caret-color: black !important;
    font-weight: 700;
  }

  .v-list-item--link:before {
    background-color: #ECF5FB !important;
    z-index: 3;
  }

  .st-app .v-treeview-node--active,
  .st-app .v-list-item--active,
  nav .v-list-item--active {
    font-weight: 600;

  }

  .st-app .theme--light.v-list-item--active::before,
  nav .theme--light.v-list-item--active::before {
    z-index: 2;
    opacity: 1;
  }

  .st-app .v-treeview-node--active,
  .st-app .v-list--rounded .v-list-item,
  .v-list--rounded .v-list-item::before,
  .v-list--rounded .v-list-item>.v-ripple__container,
  nav .v-list--rounded .v-list-item,
  .v-list--rounded .v-list-item::before,
  .v-list--rounded .v-list-item>.v-ripple__container {
    border-radius: 12px !important;
  }

  .st-app .v-list-group__items,
  nav .v-list-group__items {
    position: relative;
    margin-bottom: 20px;
    color: white;
  }

  .st-app .v-list-item .v-list-group__items .v-list-item__title,
  nav .v-list-item .v-list-group__items .v-list-item__title {
    font-size: 13px !important;
  }

  .st-app .v-list-item--active .v-list-item__title,
  nav .v-list-group__items .v-list-item--active .v-list-item__title {
    color: white !important;
    font-weight: 600;
  }


  .st-app .v-list-group__items .v-list-item--active::before,
  nav .v-list-group__items .v-list-item--active::before {
    z-index: 2;
    opacity: 1;
  }

  .st-app .v-list-group__items .v-list-item:hover::before,
  nav .v-list-group__items .v-list-item:hover::before {
    opacity: 0 !important;
  }

  .st-app .child-link .v-list-item--active:hover::before,
  nav .child-link .v-list-item--active:hover::before {
    opacity: 1 !important;
  }

  .st-app .child-link .child-group .v-list-item--active:hover::before,
  nav .child-link .child-group .v-list-item--active:hover::before {
    opacity: 0 !important;
  }

  .st-app .v-list-group__items .v-list-item--active:hover::before,
  nav .v-list-group__items .v-list-item--active:hover::before {
    opacity: 1 !important;
  }

  .st-app .v-treeview-node--active,
  .st-app .v-list-item--active::before,
  nav .v-list-group__items .v-list-item--link::before {
    background-color: #1976D2 !important;
  }

  .st-app .child-link .child-group .v-list-item--active:hover::before,
  nav .child-link .child-group .v-list-item--active:hover::before {
    opacity: 0 !important;
  }

  .st-app .child-link .child-group .v-list-group__items .v-list-item--active:hover::before,
  nav .child-link .child-group .v-list-group__items .v-list-item--active:hover::before {
    opacity: 1 !important;
  }

  .st-app .child-group .v-list-group__items::before,
  nav .child-group .v-list-group__items::before {
    content: '';
    background: #ECF5FB;
    width: 200%;
    height: calc(100% + 20px);
    margin-top: -10px;
    position: absolute;
    margin-left: -50%;
  }

  .st-app .icon-image,
  nav .icon-image {
    z-index: 10;
  }

  .st-app .v-treeview-node--active .mdi,
  .st-app .v-treeview-node--active .v-treeview-node__content {
    color: #ECF5FB;
  }

  .desktop-versioning {
    color: black;
    position: absolute;
    right: 64px;
    bottom: -14px;
    font-size: 0.55rem;
    font-weight: bold;
  }

  .mobile-versioning {
    color: black;
    position: absolute;
    right: 122px;
    bottom: -14px;
    font-size: 0.55rem;
    font-weight: bold;
  }

  .v-main.grey.lighten-4.mx-4.mt-4 {
    padding-top: 15px !important;
  }

  .success--text {
    z-index: 1;
  }

  .warning--text {
    z-index: 1;
  }

  .error--text {
    z-index: 1;
  }

  .edited--text {
    z-index: 1;
    color: #1976D2;
  }

  .hover-pointer:hover {
    cursor: pointer;
    background: #f5f9ff;
  }

  .language-switch.v-text-field.v-text-field--solo .v-input__control {
    min-height: 30px !important;
  }

  .font-lang-14 {
    font-size: 14px !important;
  }

  .font-lang-12 {
    font-size: 14px !important;
  }

  .red-notification {
    background-color: #E64A4D;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 2px;
  }

</style>

<style lang="scss">
.feedbackText {
  position: absolute;
  border-radius: 4px 0px 0px 4px;
  background: #3277D5;
  right: -10px;
  top: 80vh;
  color: #FFFFFF;
  width: 40px;
  height: 40px;
  padding: 6px;
  font-weight: 600;
  font-size: 12px;
  transition: width 0.3s ease-in-out;

  &:hover {
    width: 106px !important;
    background: #3277D5;
    right: 0 !important;
  }
}


</style>

